import { removeItemByIndex, removeItemsByIds } from '@/core/utils/arrays';
import { createLocationHubCacheListener, createSocketMessageEventListener, fixBlockedItemMessage } from '@/warehouse/signalR';
import { blockedOnPickingMessageSchema, returnedFromBlockToPickingMessageSchema, returnedFromBlockToStockMessageSchema, } from '@/warehouse/signalR/types';
import { t } from '@/core/localization';
import { convertDateRangeValueToApiFormat } from '@/core/utils/datetime';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { baseApi } from '@/warehouse/baseApi';
import { stockBlockedActions } from './stockBlocked.state';
export const stockBlockedApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getBlockedItems: builder.query({
            query: ({ locationId, ...range }) => ({
                method: 'GET',
                url: `stock/${locationId}/block/items`,
                params: convertDateRangeValueToApiFormat(range),
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                    dispatch(stockBlockedActions.setItemCount(result.data?.length ?? 0));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.blocked.items.request.failed'), error }));
                }
            },
            onCacheEntryAdded: createLocationHubCacheListener(({ updateCachedData, getCacheEntry }) => {
                const { endpointName } = getCacheEntry();
                const blockedOnPickingEventListener = createSocketMessageEventListener({
                    endpointName,
                    validationSchema: blockedOnPickingMessageSchema,
                    validationSchemaPath: 'blockedItem',
                    messageMutation: (message) => {
                        // TODO: to delete later (this is backend bugs fixes)
                        fixBlockedItemMessage(message);
                    },
                    listener: ({ message, endpointName, eventName }) => {
                        updateCachedData((draft) => {
                            const listItemIndex = draft.findIndex((item) => item.id === message.blockedItem.id);
                            if (listItemIndex !== -1) {
                                // TODO: add backend log
                                console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event, BlockedItem with id:${message.blockedItem.id} already exists.`);
                                console.log('Existed item:', draft[listItemIndex]);
                                console.log('New message item:', message);
                                return;
                            }
                            draft.unshift(message.blockedItem);
                        });
                    },
                });
                const returnedFromBlockToPickingEventListener = createSocketMessageEventListener({
                    endpointName,
                    validationSchema: returnedFromBlockToPickingMessageSchema,
                    validationSchemaPath: 'blockedItemIds',
                    listener: ({ message }) => {
                        updateCachedData((draft) => {
                            // `return` in `updateCachedData` means to replace old draft value with the new one (immer).
                            return removeItemsByIds(draft, message.blockedItemIds, 'id');
                        });
                    },
                });
                const returnedFromBlockToStockEventListener = createSocketMessageEventListener({
                    endpointName,
                    validationSchema: returnedFromBlockToStockMessageSchema,
                    listener: ({ message, endpointName, eventName }) => {
                        updateCachedData((draft) => {
                            const { id, quantity } = message.blockedItem;
                            const itemIndex = draft.findIndex((item) => item.id === id);
                            if (itemIndex === -1) {
                                // TODO: (later) add error log to backend.
                                console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event has wrong id: `, id);
                                return;
                            }
                            if (quantity === 0) {
                                removeItemByIndex(draft, itemIndex);
                                return;
                            }
                            draft[itemIndex].quantity = quantity;
                        });
                    },
                });
                return {
                    BlockedOnPicking: blockedOnPickingEventListener,
                    ReturnedFromBlockToPicking: returnedFromBlockToPickingEventListener,
                    ReturnedFromBlockToStock: returnedFromBlockToStockEventListener,
                };
            }),
        }),
        // blockUnblockSticker: builder.mutation<void, PlacementItemBlock>({
        // 	query: (body) => ({
        // 		method: 'POST',
        // 		url: `crossdocking/${getCrossdockingId()}/sticker/block`,
        // 		body,
        // 	}),
        // 	invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'Placement', id: stickerId }]),
        // }),
        // TODO: later. to delete comment when `stockItemId` is really returned by request.
        // unblockToStock: builder.mutation<void, ReturnToStockBlockedItem>({
        unblockToStock: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `stock/${body.locationId}/block/return`,
                body,
            }),
            // Invalidated by socket messages.
            // invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'BlockedStickers', id: stickerId }]),
        }),
    }),
});
export const { useGetBlockedItemsQuery } = stockBlockedApi;
